import styled from 'styled-components';
import { P } from 'sushiweb/Typography/Text';

export const DataFetchError = styled.div`
  width: 100%;
  padding: 12rem 0;
  margin: auto;
  flex-direction: column;
`;

export const Title = styled(P)`
  font-size: 2.4rem;
  text-align: center;
  margin: 2rem 0 2.4rem;
`;
